export const employers = [
  {
    id: 1,
    imgUri: "https://assets.qliro.com/shared/se/sv/logo/1/logo_text_mint.png",
    altText: "qliro logo",
    title: "Software Engineer",
    description: "May 2022 - Present",
  },
  {
    id: 2,
    imgUri:
      "https://getflowbox.com/wp-content/uploads/2024/06/flowbox-logo.svg",
    altText: "flowbox logo",
    title: "Team Lead and Front-end Developer",
    description: "Dec 2020 - April 2022",
  },
  {
    id: 3,
    imgUri: "https://saltsthlm.github.io/protips/salt-logo.png",
    altText: "salt logo",
    title: "Full-stack JavaScript - School of Applied Technology </salt>",
    description:
      "Intensive three month training program for full-stack web development with a focus on TDD, mob programming, and applied learning.",
  },
];
